var getUnreadMessagesFromDatabase = () => {
    return dispatch => {
        const token = localStorage.token;
        if (token) {
            console.log("get unread messages new");
            return fetch("api/UnreadMessageUser/List", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }).then(results => {
                return results.json();
            })
                .then(results => {
                    console.log("unreadmessagefromdb: ", results);
                    dispatch({ type: "UNREAD_MESSAGE_FETCH", payload: results });
                })
        }
    }
}

var setUnreadMessagesFromDb = (unreadUserIds) => {
    return dispatch => {
        const token = localStorage.token;
        if (token) {
            return fetch("api/UnreadMessageUser/SaveUnreadMessages", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify(unreadUserIds)
            })
        }
    }
}

export default { 'GET_UNREAD_IDS': getUnreadMessagesFromDatabase, 'SET_UNREAD_IDS': setUnreadMessagesFromDb };


// WEBPACK FOOTER //
// ./src/actions/unread_message_actions.js


// WEBPACK FOOTER //
// ./src/actions/unread_message_actions.js